import script from "./MarketingExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingExpenses.vue?vue&type=script&setup=true&lang=js"

import "./MarketingExpenses.vue?vue&type=style&index=0&id=f82ae480&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82ae480"]])

export default __exports__